import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CodeIcon from '@mui/icons-material/Code';
import SearchIcon from '@mui/icons-material/Search';
import ContactsIcon from '@mui/icons-material/Contacts';
import LogoutIcon from '@mui/icons-material/Logout';
import type {SxProps} from '@mui/material';
import {Button} from '@mui/material';
import Box from '@mui/material/Box';
import type * as React from 'react';
import {Link} from 'react-router-dom';
import useFetchCourseApprovals from '@/queries/useFetchCourseApprovals';
import {useUserContext} from "@/components/Providers/UserContext";

type Props = {
    sx ?: SxProps;
};

const UserHeaderLinks = ({sx} : Props) : React.ReactElement => {
    const {user} = useUserContext();
    const courseApprovalsQuery = useFetchCourseApprovals();
    const courseApprovalsResponse = courseApprovalsQuery.data?.data;

    return <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        mr: 3,
        mt: 4,
        mb: 1,
        ...sx,
    }}>
        {courseApprovalsResponse?.hasApprovalAccess && <Link to={'/course-approvals'} style={{
            marginLeft: '8px',
            textDecoration: 'none',
            color: '#000',
        }}>
            <Button
                component="label"
                startIcon={<CheckBoxIcon/>}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#eee',
                        color: '#3c52b2',
                    },
                    color: '#000'
                }}
            >
                Course Approvals
            </Button>
        </Link>}
        {user?.isAdmin && <Link to={'/supervisor-access'} style={{
            marginLeft: '8px',
            textDecoration: 'none',
            color: '#000',
        }}>
            <Button
                component="label"
                startIcon={<SearchIcon/>}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#eee',
                        color: '#3c52b2',
                    },
                    color: '#000'
                }}
            >
                Supervisor Access
            </Button>
        </Link>}
        <Link to={'/my-digital-codes'} style={{
            marginLeft: '8px',
            textDecoration: 'none',
            color: '#000',
        }}>
            <Button
                component="label"
                startIcon={<CodeIcon/>}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#eee',
                        color: '#3c52b2',
                    },
                    color: '#000'
                }}
            >
                My Digital Codes
            </Button>
        </Link>
        <Link to={'/my-rentals'} style={{
            marginLeft: '8px',
            textDecoration: 'none',
            color: '#000',
        }}>
            <Button
                component="label"
                startIcon={<ContactsIcon/>}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#eee',
                        color: '#3c52b2',
                    },
                    color: '#000'
                }}
            >
                My Rentals
            </Button>
        </Link>
        <Link to={'/sign-out'} style={{
            marginLeft: '8px',
            textDecoration: 'none',
            color: '#000',
        }}>
            <Button
                component="label"
                startIcon={<LogoutIcon/>}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: '#eee',
                        color: '#3c52b2',
                    },
                    color: '#000'
                }}
            >
                Sign-Out
            </Button>
        </Link>
    </Box>;
};

export default UserHeaderLinks;
